// extracted by mini-css-extract-plugin
module.exports = {"textOverflow":"textOverflow_textOverflow__1T831"};